<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item"><router-link to="/sale/orders">{{ $t('sale_order') }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{title}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <b-btn variant="outline-primary no-bor" size="sm" @click="save"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-6">
                            <table style="width: 100%;">
                                <tbody>
                                <tr>
                                    <td style="width: 100px;">{{ $t('customer') }}</td>
                                    <td>:</td>
                                    <td><customer-selector @select="customerSelected" :value="header.CustomerName"></customer-selector></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-6">
                            <table align="right">
                                <tbody>
                                <tr>
                                    <td>{{$t('barcode')}}</td>
                                    <td>:</td>
                                    <td><input type="text" class="form-control form-control-sm" readonly v-model="header.Num"/></td>
                                </tr>
                                <tr>
                                    <td>{{$t('date')}}</td>
                                    <td>:</td>
                                    <td>
                                        <input type="date" class="form-control form-control-sm" v-model="date"/>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="grid">
                                <thead>
                                <tr>
                                    <th style="width: 30px;"></th>
                                    <th>{{$t('item_name')}}</th>
                                    <th style="width: 100px;">{{$t('qty')}}</th>
                                    <th style="width: 120px;">{{$t('uom')}}</th>
                                    <th style="width: 100px;">{{$t('unit_price')}}</th>
                                    <th style="width: 100px;">{{$t('tax_line')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('amount')}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(ret,index) in lines" :key="ret.Id">
                                    <td style="width: 30px;">
                                        <button type="button" class="btn btn-danger btn-remove" @click="onRemove(index)">X</button>
                                    </td>
                                    <td><AuthCompleted @select="itemSelect($event, ret)" :value="ret.ItemName"></AuthCompleted></td>
                                    <td class="text-center">
                                        <input type="number" class="form-control form-control-sm" v-model="ret.Quantity" @keypress="$isKeyNumber" @change="reCalculate" :disabled="ret.ItemId==''">
                                    </td>
                                    <td>
                                        <UomDropdown :value="ret.UomName" :item_id="ret.ItemId" @select="uomChange($event, ret)"></UomDropdown>
                                    </td>
                                    <td class="text-right">
                                        <input type="number" class="form-control form-control-sm" v-model="ret.Price" @keypress="$isKeyNumber" @change="reCalculate" :disabled="ret.ItemId==''">
                                    </td>
                                    <td class="text-right">
                                        <input type="number" class="form-control form-control-sm" v-model="ret.TaxLine" @keypress="$isKeyNumber" @change="reCalculate" :disabled="ret.ItemId==''">
                                    </td>
                                    <td class="text-right">
                                        <input type="text" class="form-control form-control-sm text-right" :value="$money(ret.SubTotal)" readonly />
                                    </td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <td></td>
                                    <td colspan="3" rowspan="3" style="vertical-align: top;">
                                        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="addLine"><i class="fa fa-plus"></i> {{ $t('add_line') }}</button>
                                    </td>
                                    <th colspan="2" class="text-right">{{$t('untax_amount')}}:</th>
                                    <th class="text-right">{{$money(header.GrandTotal)}}</th>
                                </tr>
                                <tr>
                                    <td></td>
                                    <th colspan="2" class="text-right">{{$t('taxes')}}:</th>
                                    <th class="text-right">{{$money(header.TaxVat)}}</th>
                                </tr>
                                <tr>
                                    <td></td>
                                    <th colspan="2" class="text-right">{{$t('total')}}:</th>
                                    <th class="text-right">{{$money(header.PaidAmount)}}</th>
                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { AuthCompleted } from '../../Item';
    import { CustomerSelector } from '../../Customer';
    import UomDropdown from '../../UOM/Dropdown';
    export default {
        components: {
            AuthCompleted,
            CustomerSelector,
            UomDropdown
        },
        data: function(){
            return {
                title: this.$t('sale_order_create'),
                header: {
                    CustomerId: '',
                    ShipperId: '',
                },
                lines: [{
                    Id: '',
                    ShippingType: '',
                    ChargeAmount: '',
                    Status: '',
                }],
                date: this.$now().format('YYYY-MM-DD'),
            }
        },
        created(){
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                let loading = this.$loading.show();
                this.$api().post('deliveries/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        let data = res.data.Json;
                        this.header = data.Header;
                        this.lines = data.Lines;
                        this.title = this.$t('sale_order_update') +' ['+ this.header.Num + ']';
                    }
                }).finally(function(){ loading.hide(); });
            }
        },
        methods: {
            addLine(){
                this.lines.push({
                    Id: '',
                    ShippingType: '',
                    ChargeAmount: '',
                    Status: '',
                });
            },
            save(){
                if(this.lines.length > 0){
                    let loading = this.$loading.show();
                    this.header.Date = this.date;
                    var req = {
                        Header: this.header,
                        Lines: this.lines
                    };
                    this.$api().post('delivery/save', req).then(res => {
                        if(this.$isValid(res)){
                            this.$router.push('/sale/delivery');
                        }
                    }).finally(function() { loading.hide();});
                }
            },
            customerSelected(evt){
                this.header.CustomerId = evt.Id;
                this.header.CustomerName = evt.Name;
            },
            reCalculate(){
                let grand_total = 0;
                let taxs = 0;
                let total = 0;
                let discount = 0;
                this.lines.map(item => {
                    let grand = item.Quantity * item.Price;
                    let dis = grand * (item.Discount / 100);
                    let line_untax = grand - dis;
                    let line_tax = line_untax * (item.TaxLine / 100);
                    let line_sub = line_untax + line_tax;
                    item.SubTotal = line_sub;
                    grand_total += grand;
                    discount += dis;
                    taxs += line_tax;
                    total += line_sub;
                });
                this.header.Discount = discount;
                this.header.GrandTotal = grand_total;
                this.header.TaxVat = taxs;
                this.header.PaidAmount = total;
            },
            itemSelect(evt, line){
                line.ItemId = evt.Id;
                line.ItemName = evt.Name;
                line.Price = evt.Price;
                this.reCalculate();
            },
            onRemove(index){
                this.lines.splice(index, 1);
                this.reCalculate();
            },
            uomChange(e, line){
                line.UomId = e.UomId;
                line.UomName = e.UomName;
                line.Price = e.Price;
                this.reCalculate();
            }
        }
    }
</script>
